// import appConfig from "../config/app.config";

import { makeGetRequest } from "../services/makeRequest";
import { EVENT_SOURCE_CHANNEL_MAP } from "../constants";
import { getOrCreateGa4ClientId } from "./utils";

const ALL = "ALL";
const GOOGLE = googleSDK;
const PIXEL = pixelSDK;
const APPSFLYER = appsflyerSDK;
const SEGMENT = segmentSDK;
const CLEVERTAP = clevertapSDK;

const SDKList = [GOOGLE, PIXEL, SEGMENT, CLEVERTAP, APPSFLYER];

const isEmptyAnalyticsValue = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (typeof value === "number" && Number.isNaN(value)) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (
    value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.keys(value).length === 0
  ) {
    return true;
  }
  return false;
};

const sanitizeAnalyticsPayload = (obj) => {
  try {
    if (!obj || typeof obj !== "object") return {};
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      if (isEmptyAnalyticsValue(value)) return acc;
      acc[key] = value;
      return acc;
    }, {});
  } catch (e) {
    return {};
  }
};

//SDK functions defination (guarded so one missing SDK doesn't break others)
function googleSDK(eventName, eventValue, sendTo) {
  try {
    if (!window || !window.gtag) return false;
    const eventData = Object.assign(
      {
        send_to: sendTo || process.env.REACT_APP_GTAG_LOCATION,
      },
      eventValue,
    );
    window.gtag("event", eventName, eventData || {});
    return true;
  } catch (error) {
    return false;
  }
}

function pixelSDK(eventName, eventValue) {
  try {
    if (!window || !window.fbq) return false;
    window.fbq("trackCustom", eventName, eventValue || {});
    return true;
  } catch (error) {
    return false;
  }
}

function appsflyerSDK(eventName, eventValue) {
  try {
    if (!window || !window.AF) return false;
    window.AF("pba", "event", {
      eventType: "EVENT",
      eventName: eventName,
      eventValue: eventValue || {},
    });
    return true;
  } catch (error) {
    return false;
  }
}

function segmentSDK(eventName, eventValue = {}) {
  try {
    sendEvent(eventName, eventValue);
    return true;
  } catch (error) {
    return false;
  }
}

function clevertapSDK(eventName, eventValue) {
  try {
    if (!window || !window.clevertap || !window.clevertap.event) return false;
    const cleaned = sanitizeAnalyticsPayload(eventValue || {});
    window.clevertap.event.push(eventName, cleaned);
    return true;
  } catch (error) {
    return false;
  }
}

const eventSDKSelector = (eventName, eventValue, SDKOptions, sendTo = null) => {
  try {
    if (SDKOptions === ALL) {
      SDKList.forEach((sdkFunction) => {
        sdkFunction(eventName, eventValue, sendTo);
      });
      return true;
    } else if (SDKOptions.length > 0) {
      SDKOptions.forEach((sdkFunction) => {
        sdkFunction(eventName, eventValue, sendTo);
      });
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const hitEverFlowApi = async (txnId, url) => {
  await makeGetRequest(`${url}&transaction_id=${txnId}`, {
    Accept:
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7",
  });
};

const getPlatform = () => {
  try {
    // Prefer explicit webview bridges
    if (typeof window !== "undefined") {
      if (
        typeof window.webkit?.messageHandlers?.tilAppWebBridge !== "undefined"
      ) {
        return "ios";
      }
      if (typeof window.tilAppWebBridge !== "undefined") {
        return "android";
      }
    }
    return "web";
  } catch (e) {
    return "web";
  }
};

const ga4CollectBaseEndpoint = process.env.REACT_APP_GA4_COLLECT_ENDPOINT;

const sendEvent = async (eventName, obj = {}, sendTo) => {
  const channel = sessionStorage.getItem("channel") || "";
  const eventSource = EVENT_SOURCE_CHANNEL_MAP[channel] || "";
  const toiEmail = sessionStorage.getItem("email") || "";
  if (toiEmail) {
    obj.toiEmail = toiEmail;
    obj.email = toiEmail;
  }
  if (obj.Phone_Number) {
    obj.phone_number = obj.Phone_Number;
  }
  if(obj.utm_source){
      window.console.log("utm_source")
  }
  else if (eventSource) {
    obj.channel = eventSource;
    obj.utm_source = eventSource;
  }else{
    obj.utm_source = getUtmSource();
    obj.utm_medium = getUtmMedium();
    obj.utm_campaign = getUtmCampaign();
  }
  if (eventName === "identity") {
    obj = sanitizeAnalyticsPayload(obj);
  }

  /*
  try {
    switch (eventName) {
      case "Homepg_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Get_started_clicked":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Signup_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Signup_completed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Bank_link_started":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Bank_link_completed":
        return eventSDKSelector("Web_Bank_link_completed_frontend", obj, ALL);
      case "Web_card_cross_clicked":
        return eventSDKSelector("Web_card_cross_clicked", obj, ALL);

      case "Dwnld_CTA_clicked":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_flow_started":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_flow_completed":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_flow_exited":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_bank_selected":
        return eventSDKSelector(eventName, obj, ALL);

      case "Plaid_bank_login_success":
        return eventSDKSelector(eventName, obj, ALL);

      case "CompleteRegistration":
        return eventSDKSelector(eventName, obj, [PIXEL, GOOGLE], sendTo);

      case "conversion":
        return eventSDKSelector(eventName, obj, [GOOGLE], sendTo);

      case "willow_signup_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_signup_completed":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_signup_downloaded":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_cancel_landed":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_cancel_successful":
        return eventSDKSelector(eventName, obj, ALL);

      case "willow_cancel_downloaded":
        return eventSDKSelector(eventName, obj, ALL);

      case "add_to_wishlist":
        return eventSDKSelector(eventName, obj, ALL);

      case "generate_lead":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_phone_number_added":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_phone_number_verified":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_Bank_link_completed_frontend":
        return eventSDKSelector(eventName, obj, ALL);

      case "Web_card_popup_fired":
        return eventSDKSelector(eventName, obj, ALL);

      case "Cricbuzz_phone_number_added":
        return eventSDKSelector(eventName, obj, ALL);

      case "Cricbuzz_phone_number_verified":
        return eventSDKSelector(eventName, obj, ALL);

      case "Cricbuzz_phone_number_screen_landed":
        return eventSDKSelector(eventName, obj, ALL);
      default:
        return eventSDKSelector(eventName, obj, ALL);
      // console.log("No event selected");
    }
  } catch (error) {
    return error;
  }*/

  try {
    // GA4 requires `cid` to be a stable identifier for the session/device.
    let cid = sessionStorage.getItem('distinct_id') || getOrCreateGa4ClientId();
    const endpoint = `${ga4CollectBaseEndpoint}`;

    const platform = getPlatform();
    // Always include platform=WEB
    if(platform === "ios"){
        cid = cid.toUpperCase()
    }
    const payload = {
      en: eventName,
      "ep.platform": "WEB",
      "ep.client_platform": platform,
      "ep.distinct_id": cid,
    };

    // Add dynamic properties
    Object.keys(obj).forEach((key) => {
      payload[`ep.${key}`] = obj[key];
    });

    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: new URLSearchParams(payload).toString(),
    });
  } catch (error) {
    console.error("Error sending event:", error);
    throw error;
  }
};

const setClevertapProfile = (obj) => {
  try {
    if (!obj) return false;
    if (
      typeof window === "undefined" ||
      !window.clevertap ||
      !window.clevertap.profile
    ) {
      return false;
    }

    // CleverTap logs warnings for null/undefined values (e.g., email: null).
    // Drop only nullish/empty-string/NaN values; keep false/0.
    const cleaned = sanitizeAnalyticsPayload(obj);

    if (Object.keys(cleaned).length === 0) return false;

    window.clevertap.profile.push({
      Site: cleaned,
    });
    return true;
  } catch (e) {
    return false;
  }
};

const setMixpanelProfile = (obj) => {
  // if (obj) {
  //   window.mixpanel.people.set(obj);
  //   return true;
  // }
  return false;
};

const setAFCustomerUserId = (id) => {
  window.AF("pba", "setCustomerUserId", String(id));
};

const getUtmSource = () => {
  setUtmData();
  return sessionStorage.getItem("utm_source") || "organic";
};

const getUtmMedium = () => {
  return sessionStorage.getItem("utm_medium") || "";
};

const getUtmCampaign = () => {
  return sessionStorage.getItem("utm_campaign") || "";
};

const setUtmData = () => {
  const windowUrl = new URL(window.location.href);
  const utm_source = windowUrl.searchParams.get("utm_source")
    ? windowUrl.searchParams.get("utm_source")
    : "";
  const utm_medium = windowUrl.searchParams.get("utm_medium")
    ? windowUrl.searchParams.get("utm_medium")
    : "";
  const utm_campaign = windowUrl.searchParams.get("utm_campaign")
    ? windowUrl.searchParams.get("utm_campaign")
    : "";

  const prev_utm_source = sessionStorage.getItem("utm_source");
  const prev_utm_medium = sessionStorage.getItem("utm_medium");
  const prev_utm_campaign = sessionStorage.getItem("utm_campaign");

  if (utm_source == "") {
    if (!prev_utm_source) {
      sessionStorage.setItem("utm_source", "organic");
    }
  } else if(!prev_utm_source){
        sessionStorage.setItem("utm_source", utm_source);
      
  }

  if (prev_utm_medium === null || utm_medium !== "") {
    sessionStorage.setItem("utm_medium", utm_medium);
  }

  if (prev_utm_campaign === null || utm_campaign !== "") {
    sessionStorage.setItem("utm_campaign", utm_campaign);
  }
};

const Homepg_landed = (obj) => {
  try {
    if (!obj.utm_source) {
      throw new Error("utm_source required");
    }
    return sendEvent("Homepg_landed", {
      utm_source: obj.utm_source,
      utm_medium: obj.utm_medium || "",
      utm_campaign: obj.utm_campaign || "",
    });
  } catch (error) {
    return error;
  }
};

const Get_started_clicked = (obj = {}) => {
  try {
    if (!obj.click_source) {
      throw new Error("click_source required");
    }
    if (!["header", "main", "footer", "login_pg"].includes(obj.click_source)) {
      throw new Error("invalid click_source");
    }

    return sendEvent("Get_started_clicked", {
      click_source: obj.click_source,
      carousel_pos: obj.carousel_pos,
    });
  } catch (error) {
    return error;
  }
};

export const toiLandingContinueClick = (attributes = {}) => {
  sendEvent("Web_landing_countinue_click", attributes);
};

export const toiLandingPageLanded = (attributes = {}) => {
  sendEvent("Web_toi_landing_page_landed", attributes);
  const toiEmail = sessionStorage.getItem("email") || "";
  if(toiEmail) {
    sendEvent("anonymous_identity", {
      email: toiEmail,
      utm_source: "toi_mobile"
    });
  }
};

export const toiEmailUpdate = () => {
  sendEvent("Web_email_address_added");
};

export const toiKycPageLanded = () => {
  sendEvent("kyc_page_landed");
};

export const toiKycPageContinueClick = () => {
  sendEvent("kyc_page_continue_click");
};

export const toiRecipientPageLanded = () => {
  sendEvent("TOI_recipient_page_landed");
};

export const toiRecipientNameEntered = () => {
  sendEvent("TOI_recipient_name_entered");
};

export const toiRecipientAccountNumberEntered = () => {
  sendEvent("TOI_recipient_accountnumber_entered");
};

export const toiRecipientIfscEntered = () => {
  sendEvent("TOI_recipient_IFSC_entered");
};

export const toiRecipientAdded = (attributes = {}) => {
  sendEvent("TOI_recipient_added", attributes);
};

export const toiRecipientSuccessPageLanded = () => {
  sendEvent("TOI_recipient_success_page_landed");
};

export const toiRecipientSuccessContinueClick = () => {
  sendEvent("TOI_recipient_success_continue_click");
};

export const toiOtpEntered = (attributes = {}) => {
  sendEvent("web_otp_entered", attributes);
};

export const toiStartOtpFlow = (attributes = {}) => {
  sendEvent("web_start_otp_flow", attributes);
};

export const migrationPhoneEntered = (attributes = {}) => {
  sendEvent("web_phone_enter_started", attributes);
};

const Web_Signup_landed = (obj = {}) => {
  try {
    return sendEvent("Web_Signup_landed", {
      utm_source: obj.utm_source,
      utm_medium: obj.utm_medium,
      utm_campaign: obj.utm_campaign,
      user_source: obj.user_source,
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Web_Signup_completed = (obj = {}) => {
  try {
    // if (!obj.email) {
    //   throw new Error("email required");
    // }
    // if (!obj.signup_source) {
    //   throw new Error("signup_source required");
    // }
    // if (!["web", "ios"].includes(obj.signup_source)) {
    //   throw new Error("invalid signup_source");
    // }
    const everflowTxnId = obj?.everflowTxnId || "";
    if (everflowTxnId) {
      hitEverFlowApi(
        everflowTxnId,
        process.env.REACT_APP_SIGNUP_EVERFLOW_ENDPOINT,
      );
    }

    return sendEvent("Web_Signup_completed", obj);
  } catch (error) {
    return error;
  }
};

const Add_To_Wishlist = (obj = {}) => {
  try {
    return sendEvent("add_to_wishlist", {
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Generate_Lead = (obj = {}) => {
  try {
    return sendEvent("generate_lead", {
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Web_Bank_link_started = (obj) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }
    if (!obj.type) {
      throw new Error("type required");
    }
    if (!["clo", "plaid"].includes(obj.type)) {
      throw new Error("invalid type");
    }
    return sendEvent("Web_Bank_link_started", {
      type: obj.type,
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Web_Bank_link_completed = (obj = {}) => {
  try {
    if (!obj.web_bank_linked) {
      throw new Error("web_bank_linked required");
    }
    if (![true, false].includes(obj.web_bank_linked)) {
      throw new Error("invalid web_bank_linked");
    }
    if (!obj.email) {
      throw new Error("email required");
    }
    if (!obj.type) {
      throw new Error("type required");
    }
    if (!["clo", "plaid"].includes(obj.type)) {
      throw new Error("invalid type");
    }

    return sendEvent("Web_Bank_link_completed", {
      web_bank_linked: obj.web_bank_linked,
      no_of_active_banks: obj.no_of_active_banks || 0,
      utm_source: obj.utm_source,
      utm_medium: obj.utm_medium,
      utm_campaign: obj.utm_campaign,
      type: obj.type,
      email: obj.email,
    });
  } catch (error) {
    return error;
  }
};

const Conversion = (obj = {}) => {
  try {
    return sendEvent(
      "conversion",
      {
        value: obj.value,
        currency: obj.currency,
        transaction_id: obj.transaction_id,
      },
      "AW-658129294/BC5TCL3z8ocYEI6D6bkC",
    );
  } catch (error) {
    return error;
  }
};

const HQUserSignup = ({ utm_content, utm_source }) => {
  try {
    if (utm_source === "everflow") {
      hitEverFlowApi(
        utm_content,
        process.env.REACT_APP_HQ_SIGNUP_EVERFLOW_ENDPOINT,
      );
    }
    return sendEvent("conversion", null, "AW-658129294/y1ldCOy3h6gYEI6D6bkC");
  } catch (error) {
    return error;
  }
};

const HQUserBankAdd = (obj = {}) => {
  try {
    return sendEvent(
      "conversion",
      {
        transaction_id: obj.transaction_id,
      },
      "AW-658129294/7rUtCP3z_acYEI6D6bkC",
    );
  } catch (error) {
    return error;
  }
};

const Dwnld_CTA_clicked = (obj = {}) => {
  try {
    if (!obj.platform_selected) {
      throw new Error("platform_selected required");
    }
    if (!["iOS", "Android"].includes(obj.platform_selected)) {
      throw new Error("invalid platform_selected");
    }
    return sendEvent("Dwnld_CTA_clicked", {
      platform_selected: obj.platform_selected,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_flow_started = (obj = {}) => {
  try {
    return sendEvent("Plaid_flow_started");
  } catch (error) {
    return error;
  }
};

const Plaid_flow_completed = (obj = {}) => {
  try {
    if (!obj.bank_name) {
      throw new Error("bank_name required");
    }

    return sendEvent("Plaid_flow_completed", {
      bank_name: obj.bank_name,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_flow_exited = (obj = {}) => {
  try {
    // if (!obj.bank_name) {
    //   throw new Error("bank_name required");
    // }

    // if (!obj.exit_screen) {
    //   throw new Error("exit_screen required");
    // }

    if (!obj.status) {
      throw new Error("status required");
    }

    return sendEvent("Plaid_flow_exited", {
      bank_name: obj.bank_name,
      exit_screen: obj.exit_screen,
      error_code: obj.error_code || null,
      status: obj.status,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_bank_selected = (obj = {}) => {
  try {
    if (!obj.bank_name) {
      throw new Error("bank_name required");
    }

    return sendEvent("Plaid_bank_selected", {
      bank_name: obj.bank_name,
    });
  } catch (error) {
    return error;
  }
};

const Plaid_bank_login_success = (obj = {}) => {
  try {
    if (!obj.bank_name) {
      throw new Error("bank_name required");
    }

    return sendEvent("Plaid_bank_login_success", {
      bank_name: obj.bank_name,
    });
  } catch (error) {
    return error;
  }
};

const CompleteRegistration = (obj = {}) => {
  try {
    return sendEvent(
      "CompleteRegistration",
      null,
      "AW-658129294/JRfiCNbu8ocYEI6D6bkC",
    );
  } catch (error) {
    return error;
  }
};

const getAFUserId = () => {
  if (!document?.cookie) {
    return "";
  }
  return document.cookie
    .split(";")
    .filter((p) => p.includes("afUserId"))?.[0]
    ?.split("=")[1];
};

const willow_signup_landed = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }

    return sendEvent("willow_signup_landed", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_signup_completed = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }
    return sendEvent("willow_signup_completed", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_signup_downloaded = (obj = {}) => {
  try {
    if (!obj.platform_selected) {
      throw new Error("platform_selected required");
    }
    if (!["ios", "android", "email"].includes(obj.platform_selected)) {
      throw new Error("invalid platform_selected");
    }

    return sendEvent("willow_signup_downloaded", {
      platform_selected: obj.platform_selected,
    });
  } catch (error) {
    return error;
  }
};

const willow_cancel_landed = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }

    return sendEvent("willow_cancel_landed", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_cancel_successful = (obj = {}) => {
  try {
    if (!obj.email) {
      throw new Error("email required");
    }
    return sendEvent("willow_cancel_successful", {
      email: obj.email,
      subscription_plan: obj.plan,
    });
  } catch (error) {
    return error;
  }
};

const willow_cancel_downloaded = (obj = {}) => {
  try {
    if (!obj.platform_selected) {
      throw new Error("platform_selected required");
    }
    if (!["ios", "android", "email"].includes(obj.platform_selected)) {
      throw new Error("invalid platform_selected");
    }

    return sendEvent("willow_cancel_downloaded", {
      platform_selected: obj.platform_selected,
    });
  } catch (error) {
    return error;
  }
};

const handleEverflowEvents = (eventName, everflowTxnId) => {
  switch (eventName) {
    case "Remittance_approved":
      hitEverFlowApi(
        everflowTxnId,
        process.env.REACT_APP_REMITTANCE_APPROVE_EVERFLOW_ENDPOINT,
      );
      break;
    default:
      break;
  }
};

const postMparticleEvent = (
  { eventName, eventType, attributes = {} },
  utmInfo = {},
) => {
  // Now using Segment instead of mparticle
  const { utm_source, utm_content } = utmInfo || {};
  const channel = sessionStorage.getItem("channel") || "";
  const eventSource = EVENT_SOURCE_CHANNEL_MAP[channel] || "";
  if (eventSource) {
    attributes.channel = eventSource;
  }
  try {
    if (utm_source === "everflow") {
      handleEverflowEvents(eventName, utm_content);
    }
    sendEvent(eventName, attributes);
    eventSDKSelector(eventName, attributes, [GOOGLE]);
    // const nbEventsPostToPixel = ["NBkyc_SSN_verified", "Remittance_approved"];
    // if (nbEventsPostToPixel.includes(eventName)) {
    //   eventSDKSelector(eventName, attributes, [PIXEL]);
    // }
    // if (hasUserAttributes) {
    //   addDeleteUserAttributes("DELETE", attributes);
    // }
  } catch (error) {
    console.log("Failed to post events with Segment.");
    return error;
  }
};

const Web_phone_number_added = (obj = {}) => {
  try {
    return sendEvent("Web_phone_number_added", obj);
  } catch (error) {
    return error;
  }
};

const Web_phone_number_verified = (obj = {}) => {
  try {
    return sendEvent("Web_phone_number_verified", obj);
  } catch (error) {
    return error;
  }
};

const Web_card_popup_fired = (obj = {}) => {
  try {
    return sendEvent("Web_card_popup_fired");
  } catch (error) {
    return error;
  }
};

const Web_Bank_link_completed_frontend = (obj = {}) => {
  try {
    return sendEvent("Web_Bank_link_completed_frontend", obj);
  } catch (error) {
    return error;
  }
};

const Web_card_cross_clicked = (obj = {}) => {
  try {
    return sendEvent("Web_card_cross_clicked");
  } catch (error) {
    return error;
  }
};

const Cricbuzz_phone_number_added = (obj = {}) => {
  try {
    if (!obj.phone_number) {
      throw new Error("Phone Number required");
    }
    return sendEvent("Cricbuzz_phone_number_added", {
      email: obj.email,
      phone_number: obj.phone_number,
      subscription_plan: obj.subscription_plan,
    });
  } catch (error) {
    return error;
  }
};
const Cricbuzz_phone_number_verified = (obj = {}) => {
  try {
    if (!obj.phone_number) {
      throw new Error("Phone Number required");
    }

    return sendEvent("Cricbuzz_phone_number_verified", {
      email: obj.email,
      phone_number: obj.phone_number,
      subscription_plan: obj.subscription_plan,
    });
  } catch (error) {
    return error;
  }
};

const Cricbuzz_phone_number_screen_landed = (obj = {}) => {
  try {
    return sendEvent("Cricbuzz_phone_number_screen_landed", {
      email: obj.email,
      subscription_plan: obj.subscription_plan,
    });
  } catch (error) {
    return error;
  }
};

const remittanceRateCardClicked = (attributes = {}) => {
  try {
    return sendEvent("remittance_rate_card_clicked", attributes);
  } catch (error) {
    return error;
  }
};

const crossWalkUserLogin = (attributes = {}) => {
  try {
    return sendEvent("crosswalk_user_login_screen_landed", attributes);
  } catch (error) {
    return error;
  }
};

const crossWalkUserLoggedIn = (attributes = {}) => {
  try {
    return sendEvent("crosswalk_user_logged_in", attributes);
  } catch (error) {
    return error;
  }
};

const toiSubCallbackSuccess = (attributes = {}) => {
  sendEvent("sub_callback_success", attributes);
};

const toiSubOtpVerificationFailed = (attributes = {}) => {
  try {
    return sendEvent("otp_verification_failed", attributes);
  } catch (error) {
    return error;
  }
};

const signupBonusBannerViewed = (obj = {}) => {
  sendEvent("signup_bonus_banner_viewed", obj);
};

const signupBonusBottomSheetViewed = (obj = {}) => {
  sendEvent("signup_bonus_bottom_sheet_viewed");
};

export {
  setUtmData,
  sendEvent,
  setAFCustomerUserId,
  setClevertapProfile,
  setMixpanelProfile,
  getAFUserId,
  getUtmSource,
  getUtmMedium,
  getUtmCampaign,
  Homepg_landed,
  Get_started_clicked,
  Web_Signup_landed,
  Web_Signup_completed,
  Web_Bank_link_started,
  Web_Bank_link_completed,
  Web_Bank_link_completed_frontend,
  Web_phone_number_added,
  Web_phone_number_verified,
  Web_card_popup_fired,
  Dwnld_CTA_clicked,
  Plaid_flow_started,
  Plaid_flow_completed,
  Plaid_flow_exited,
  Plaid_bank_selected,
  Plaid_bank_login_success,
  CompleteRegistration,
  Conversion,
  willow_signup_landed,
  willow_signup_completed,
  willow_signup_downloaded,
  willow_cancel_landed,
  willow_cancel_successful,
  willow_cancel_downloaded,
  HQUserSignup,
  HQUserBankAdd,
  Add_To_Wishlist,
  Generate_Lead,
  postMparticleEvent,
  Web_card_cross_clicked,
  Cricbuzz_phone_number_added,
  Cricbuzz_phone_number_verified,
  Cricbuzz_phone_number_screen_landed,
  remittanceRateCardClicked,
  crossWalkUserLogin,
  crossWalkUserLoggedIn,
  toiSubCallbackSuccess,
  toiSubOtpVerificationFailed,
  signupBonusBannerViewed,
  signupBonusBottomSheetViewed,
};
